<template>
  <div class="background">
  <svg width="16px" height="16px" :class="isDetail?'svgDetail':'svg'" v-if="type==='add'">
    <path
      d="M8 5.85705L9.06389 4.88182C10.5705 3.50078 13 4.56953 13 6.61332C13 7.23629 12.7525 7.83374 12.312 8.27424L8 12.5863L3.68798 8.27424C3.24747 7.83374 3 7.23629 3 6.61332C3 4.56953 5.42952 3.50078 6.93611 4.88182L8 5.85705ZM7.61184 4.14466C5.46385 2.17567 2 3.69942 2 6.61332C2 7.5015 2.35283 8.35331 2.98087 8.98135L7.85429 13.8548C7.93477 13.9352 8.06523 13.9352 8.14571 13.8548L13.0191 8.98135C13.6472 8.35331 14 7.5015 14 6.61332C14 3.69942 10.5362 2.17567 8.38816 4.14466L8 4.50048L7.61184 4.14466Z"
      fill-opacity="0.9"/>
  </svg>
  <svg width="16px" height="16px" :class="isDetail?'svgDetail':'svg'" v-else>
    <path
      d="M2 6.61332C2 3.69942 5.46385 2.17567 7.61184 4.14466L8 4.50048L8.38816 4.14466C10.5362 2.17567 14 3.69942 14 6.61332C14 7.5015 13.6472 8.35331 13.0191 8.98135L8.14571 13.8548C8.06523 13.9352 7.93477 13.9352 7.85429 13.8548L2.98087 8.98135C2.35283 8.35331 2 7.5015 2 6.61332Z"
      fill-opacity="0.9"/>
  </svg>
  </div>
</template>
<script lang="ts">
export default {
  name: 'favorite-icon',
  props: {
    type: {
      type: String,
      required: true,
      validator(value: string) {
        return ['add', 'cancel'].includes(value)
      }
    },
    isDetail: {
      type: Boolean
    }
  }
}
</script>
<style lang="scss" scoped>
.svg {
  fill: $Primary;
}
.svgDetail{
  fill: $Primary;
  margin-top: 6px;
}
.background {
  align-content: center;
  margin: 2px;
}
</style>
